module.exports = __webpack_public_path__ + "static/media/arrow-left.26db7579.svg";